<template>

    <div
        @change="sendDataForSaving"
        class="dashed-border-block training-block"
    >
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Property Name</label>
                    <input type="text" class="form-control" v-model="form.location">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">What is the name of the person who trained you</label>
                    <input type="text" class="form-control" v-model="form.trainer">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">What day did training start?</label>
                    <date-picker
                        v-model="form.training_start_day"
                        value-type="DD/MM/YYYY"
                        placeholder="Select date"
                        format="MM/DD/YYYY">
                    </date-picker>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">When did training start?</label>
                    <date-picker
                        v-model="form.training_start_time"
                        format="hh:mm a"
                        value-type="format"
                        type="time"
                        placeholder="HH:MM AM/PM"
                    ></date-picker>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">What day did training end?</label>
                    <date-picker
                        v-model="form.training_end_day"
                        value-type="DD/MM/YYYY"
                        placeholder="Select date"
                        format="MM/DD/YYYY">
                    </date-picker>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">When did training end?</label>
                    <date-picker
                        v-model="form.training_end_time"
                        format="hh:mm a"
                        value-type="format"
                        type="time"
                        placeholder="HH:MM AM/PM"
                    ></date-picker>
                </div>
            </div>
            <p>* a training without a start and end datetime will not be saved</p>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        training: {
            type: Object,
        }
    },
    name: 'TrainingItem',
    data() {
        return {
            showTimePanel: false,
            form: {
                id: null,
                index: null,
                location: null,
                trainer: null,
                training_start_day: null,
                training_end_day: null,
                training_start_time: null,
                training_end_time: null,
            }
        }
    },
    methods: {
        sendDataForSaving() {
            this.$emit('data-changed', this.form);
        },
        setData(form) {
            for (const fullKey in this.training) {
                for (const emptyKey in form) {
                    if (fullKey === emptyKey) {
                        form[fullKey] = this.training[emptyKey];
                    }
                }
            }
        },
    },
    mounted() {
        this.setData(this.form)
    }
}


</script>


<style scoped>
</style>
